module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS11.a0bec294.jpg";